module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "shop_both_area"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('filter-view', {
    attrs: {
      "propertyGroups": _vm.result.propertyGroups,
      "sc": {
        id: _vm.lastFilter.categoryId
      }
    },
    on: {
      "filterChanged": _vm.filterChanged
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('b', [(_vm.result.tag) ? _c('h2', {
    staticStyle: {
      "color": "#fff"
    }
  }, [_vm._v(_vm._s(_vm.result.tag.name))]) : _vm._e()]), _vm._v(" "), _c('b', [(_vm.lastQuery && _vm.lastQuery.length > 0) ? _c('h2', {
    staticStyle: {
      "color": "#fff"
    }
  }, [_vm._v("Jelenlegi keresés: " + _vm._s(_vm.lastQuery) + " "), _c('span', {
    staticStyle: {
      "color": "#aaa",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.$store.commit('setSearchQuery', null);
      }
    }
  }, [_vm._v("×")])]) : _vm._e()]), _vm._v(" "), (_vm.result.products != undefined) ? _c('products', {
    attrs: {
      "products": _vm.result.products.list
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.loading && (!_vm.result.products || _vm.result.products.list.length == 0)) ? _c('h2', {
    staticStyle: {
      "color": "#fff"
    }
  }, [_vm._v("A kiválasztott termék kategóriában nem található a keresésnek megfelelő termék, válasszon másik termék csoportot a termék megtalálásához!")]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loader"
  }), _vm._v(" "), (!_vm.loading && !_vm.noMorePage) ? _c('center', [_c('b', [_c('h4', {
    staticStyle: {
      "color": "#fff",
      "cursor": "pointer",
      "padding-top": "30px"
    },
    on: {
      "click": function($event) {
        _vm.loadNextPage()
      }
    }
  }, [_vm._v("További termékek betöltése")])])]) : _vm._e(), _vm._v(" "), _c('promoted')], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22fc5f18","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/main/components/pages/list/ListPage.vue
// module id = 274
// module chunks = 2